'use client'

import { useChatbot } from 'chatbot/hooks/useChatbot/useChatbot'
import { useChatbotStorage } from 'chatbot/hooks/useChatbotStorage/useChatbotStorage'
import { IconChatChatS } from 'icons/components/IconChatChatS'
import { useCallback, useMemo, useState } from 'react'
import { cx } from 'utils/cx'

import { CHATBOT_ID } from '../../constants/constants'

import style from './ChatbotButton.module.scss'
import text from 'fukku/styles/texts.module.scss'

export interface ChatbotProps {
	bodyLabel: string
	iconAlt: string
	version: number
}

export const ChatbotButton = ({
	bodyLabel,
	iconAlt,
	version,
}: ChatbotProps) => {
	const [textWidth, setTextWidth] = useState(0)
	const { isChatbotActive, openChatbot } = useChatbot({ version })
	const { isChatbotAnimationEnabled, saveInitialChatbotAnimation } =
		useChatbotStorage()

	const textRef = useCallback((node: HTMLParagraphElement) => {
		if (node !== null) {
			setTextWidth(node.getBoundingClientRect().width)
		}
	}, [])

	const chatbotStyle = useMemo(() => {
		return {
			'--button-shift': textWidth,
		}
	}, [textWidth]) as React.CSSProperties

	return (
		<>
			{!isChatbotActive && (
				<button
					data-testid='chatbot.button.open'
					className={cx(
						style.button,
						!!textWidth && !isChatbotAnimationEnabled && style.animation
					)}
					onClick={openChatbot}
					onAnimationEnd={saveInitialChatbotAnimation}
					id={CHATBOT_ID}
					type='button'
					style={chatbotStyle}
				>
					<div className={style.left}>
						<IconChatChatS className={style.icon} alt={iconAlt} />
					</div>
					<div className={style.body} />
					{!isChatbotAnimationEnabled && (
						<p ref={textRef} className={`${style.text} ${text.bodyM}`}>
							{bodyLabel}
						</p>
					)}
					<div className={style.right} />
				</button>
			)}
		</>
	)
}
